import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { DEFAULT_PAGE_SIZE } from '../../shared/utils/constants';
import MaterialTable from '../../shared/components/material-table';
import columns from './components/Columns';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../redux/actions/loadingActions';
import { courseListByFilter, removeCourse } from '../../shared/queries/Course';
import GraphQL from '../../GraphQL';
import Modal from '../../shared/components/Modal';

const Course = (props) => {
  const [data, setData] = useState([]);
  const { t, history, dispatch } = props;
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const addItemClickHandler = () => {
    history.push('/minime/curso/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/curso/mnt/${rowData.id}`);
  };

  const loadAllCourse = (filter) => {
    showLoading();
    const query = courseListByFilter(filter);
    GraphQL(query, {}).then((res) => {
      if (res.courseListByFilter) {
        res.courseListByFilter = res.courseListByFilter.map((course) => ({
          ...course,
          createdAtInMilli: format(new Date(course.createdAt), 'dd/MM/yyyy'),
          totalSteps: course.steps.length,
        }));
        setData(res.courseListByFilter);
      }
      hideLoading();
    });
  };

  const onFilterClickHandler = (filter) => {
    if (filter) {
      loadAllCourse(filter);
    } else {
      loadAllCourse({
        id: 0,
      });
    }
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeMutation = removeCourse(selectedDto.id);
    GraphQL(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {})
      .finally(() => {
        hideLoading();
        onFilterClickHandler();
      });
  };

  useEffect(() => {
    onFilterClickHandler();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    title={t('panels.curso')}
                    data={data}
                    columns={columns(t)}
                    onRefreshClick={onFilterClickHandler}
                    pageSize={DEFAULT_PAGE_SIZE}
                    deleteAction={toggleModal}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Course.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Course)
);
